<template>
    <div class="c-input-profile-item-date-of-birth">
        <div class="c-input-profile-item-date-of-birth-form is-mgb8">
            <input-profile-item-year
                :year-value="yearValue"
                :is-empty="isEmptyYear"
                :start-year="startYear"
                :end-year="endYear"
                @input="updateYear"
                data-jest="item-year"
            />
            <input-profile-item-month
                :year-value="yearValue"
                :month-value="monthValue"
                :is-empty="isEmptyMonth"
                @input="updateMonth"
                data-jest="item-month"
            />
            <input-profile-item-day
                :year-value="yearValue"
                :month-value="monthValue"
                :day-value="dayValue"
                :is-empty="isEmptyDay"
                @input="updateDay"
                data-jest="item-day"
            />
        </div>
        <p v-if="isEmptyYear && yearIsModified" class="m-text-comments is-caution" data-jest="error-text-year">生まれた年を入力してください</p>
        <p v-if="isEmptyMonth && monthIsModified" class="m-text-comments is-caution" data-jest="error-text-month">生まれた月を入力してください</p>
        <p v-if="isEmptyDay && dayIsModified" class="m-text-comments is-caution" data-jest="error-text-day">生まれた日を入力してください</p>
        <p v-if="errorText" class="m-text-comments is-caution" data-jest="error-text">{{ errorText }}</p>
    </div>
</template>

<script>
import FormSelect from "../atoms/FormSelect.vue";
import InputProfileItemDay from "./InputProfileItemDay.vue"
import InputProfileItemYear from "./InputProfileItemYear.vue";
import InputProfileItemMonth from "./InputProfileItemMonth.vue";

export default {
    name: "InputProfileItemDateOfBirth",
    components: {
        InputProfileItemMonth,
        InputProfileItemYear,
        InputProfileItemDay,
        FormSelect},
    props: {
        /**
         * yearの初期値
         */
        yearValue: {
            type: String,
            required: true
        },
        /**
         * monthの初期値
         */
        monthValue: {
            type: String,
            required: true
        },
        /**
         * dayの初期値
         */
        dayValue: {
            type: String,
            required: true
        },
        /**
         * セレクトボックスで表示する最初の年の値
         */
        startYear: {
            type: Number,
            required: true
        },
        /**
         * セレクトボックスで表示する最後の年の値
         */
        endYear: {
            type: Number,
            required: true
        },
        /**
         * 対象学年かどうか
         * こちらは中学生無料の時に使う
         */
        isApplicable: {
            type: Boolean,
            required: false,
            default: true
        },
        /**
         * エラー文言
         */
        errorText: {
            type: String,
            required: false,
            default: ''
        }
    },
    emits: ['input'],
    data() {
        return {
            birthYear: "",
            birthMonth: "",
            birthDay: "",
            yearIsModified: false,
            monthIsModified: false,
            dayIsModified: false,
        }
    },
    computed: {
        isEmptyYear() {
            return !this.birthYear;
        },
        isEmptyMonth() {
            return !this.birthMonth;
        },
        isEmptyDay() {
            return !this.birthDay;
        }
    },
    methods: {
        /**
         * emitする年月日のセット
         */
        commonEmit(yearValue, monthValue, dayValue) {
            return this.$emit("input", yearValue, monthValue, dayValue);
        },
        updateYear(value) {
            this.birthYear = value;
            this.yearIsModified = true;
            return this.commonEmit(this.birthYear, this.birthMonth, this.birthDay);
        },
        updateMonth(value) {
            this.birthMonth = value;
            this.monthIsModified = true;
            return this.commonEmit(this.birthYear, this.birthMonth, this.birthDay);
        },
        updateDay(value) {
            this.birthDay = value;
            this.dayIsModified = true;
            return this.commonEmit(this.birthYear, this.birthMonth, this.birthDay);
        },
    },
}
</script>

<style scoped lang="scss">
@use "sass:math";

.c-input-profile-item-date-of-birth {
    &-form {
        display: flex;
        justify-content: space-between;
        .m-form-select {
            width: percentage(math.div(107px, 343px));
        }
    }
}
.m-text-comments
+ .m-text-comments {
    margin-top: 0;
}
</style>
